import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-77">
          {/* Brand & Contact Column */}
          <div className="lg:col-span-1" data-id="element-78">
            <div className="flex items-center gap-2 mb-6" data-id="element-79">
              <span className="text-2xl font-bold text-white" data-id="element-80">
                Teams 'n Tees
              </span>
            </div>
            <p className="text-gray-400 mb-4 text-sm leading-relaxed" data-id="element-81">
              Custom apparel, screen printing, embroidery, and personalized
              gifts.
            </p>
            <p className="text-gray-500 text-sm mb-6" data-id="element-82">
              Based in Leonardtown, Maryland • Serving Southern Maryland
            </p>
            <div className="space-y-2 text-sm text-gray-400" data-id="element-83">
              <p data-id="element-84">
                <a href="tel:9045210580" className="hover:text-white transition-colors" data-id="element-85">
                  (904) 521-0580
                </a>
              </p>
              <p data-id="element-86">
                <a href="mailto:info@teamsntees.com" className="hover:text-white transition-colors" data-id="element-87">
                  info@teamsntees.com
                </a>
              </p>
              <p className="pt-2 text-gray-500" data-id="element-88">Mon-Fri: 9AM - 5PM</p>
            </div>
          </div>

          {/* Company Links */}
          <div data-id="element-89">
            <h3 className="text-lg font-semibold mb-6 text-teal-400" data-id="element-90">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-91">
              <li data-id="element-92">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-93">
                  About Us
                </a>
              </li>
              <li data-id="element-94">
                <a href="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-95">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services Links */}
          <div data-id="element-96">
            <h3 className="text-lg font-semibold mb-6 text-teal-400" data-id="element-97">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-98">
              <li data-id="element-99">
                <a href="/services/screen-printing" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-100">
                  Screen Printing
                </a>
              </li>
              <li data-id="element-101">
                <a href="/services/embroidery" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-102">
                  Embroidery
                </a>
              </li>
              <li data-id="element-103">
                <a href="/services/custom-apparel" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-104">
                  Custom Apparel
                </a>
              </li>
              <li data-id="element-105">
                <a href="/services/personalized-gifts" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-106">
                  Personalized Gifts
                </a>
              </li>
            </ul>
          </div>

          {/* Shop Links */}
          <div data-id="element-107">
            <h3 className="text-lg font-semibold mb-6 text-teal-400" data-id="element-108">Shop</h3>
            <ul className="space-y-3" data-id="element-109">
              <li data-id="element-110">
                <a href="/products?category=apparel" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-111">
                  Apparel
                </a>
              </li>
              <li data-id="element-112">
                <a href="/products?category=bookish" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-113">
                  Bookish
                </a>
              </li>
              <li data-id="element-114">
                <a href="/products?category=freshies" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-115">
                  Freshies
                </a>
              </li>
              <li data-id="element-116">
                <a href="/products?category=fundraisers" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-117">
                  Fundraisers
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div data-id="element-118">
            <h3 className="text-lg font-semibold mb-6 text-teal-400" data-id="element-119">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-120">
              <li data-id="element-121">
                <a href="#faqs" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-122">
                  FAQs
                </a>
              </li>
              <li data-id="element-123">
                <a href="#ordering" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-124">
                  Ordering Process
                </a>
              </li>
              <li data-id="element-125">
                <a href="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-126">
                  Custom Order Info
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8" data-id="element-127">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-128">
            <p className="text-gray-500 text-sm" data-id="element-129">
              &copy; {new Date().getFullYear()} Teams 'n Tees. All rights
              reserved.
            </p>
            <div className="flex items-center gap-4" data-id="element-130">
              <span className="text-gray-500 text-sm" data-id="element-131">Follow us:</span>
              <a href="https://www.facebook.com/tntcustomtee/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors" aria-label="Follow us on Facebook" data-id="element-132">
                <Facebook className="h-5 w-5" data-id="element-133" />
              </a>
              <div className="text-gray-600 cursor-not-allowed" aria-label="Instagram coming soon" data-id="element-134">
                <Instagram className="h-5 w-5" data-id="element-135" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}